import React, { ReactElement } from 'react';
import TPopOverContentProps from './types/TPopOverContentProps';

/**
 * This component is a wrapper the adds the prop onClose to every child node.
 * We also use it as a component type to identify which child of the PopOverWrapper
 * component contains the contents
 *
 * @param children
 * @param onClose
 * @constructor
 */
const PopOverContent = ({ children, onClose = () => {} }: TPopOverContentProps): ReactElement => (
  <>{React.Children.map(children, (child) => React.cloneElement(child, { onClose }))}</>
);

export default PopOverContent;
